import * as t from 'ts-codec';
import { date } from '@journeyapps-labs/micro-codecs';
export const TrustedProfileCreateRequest = t.object({
    profile_name: t.string,
    dob: date
});
